import { PROVINCE_AND_CITIES } from '../../../constants/areaConstants'
export function getProvinceList() {
    let provinceList = PROVINCE_AND_CITIES.map((p, i) => {
        return Object.keys(p)[0];
    });
    return provinceList;
}

export function getCityList(province) {
    let cityList = [];
    PROVINCE_AND_CITIES.forEach((p, i) => {
        if (province == Object.keys(p)[0]) {
            cityList = p[province];
        }
    });
    return cityList;
}
/**
 * (table组件)表头名转换成数据库字段名 返回驼峰形式
 * @param {string} tabColName 
 */
export function toDbColName(tabColName) {
    let dict = {
        "key": "aid",
        "名称": "areaName",
        "地区（市）": "city",
        "地区（省）": "province",
        // 序号: 114
        "状态": "status",
        "编号": "areaCode"
    }
    return dict[tabColName];
}

/**
 * 数据库字段名转换成(table组件)表头名 返回驼峰形式
 * @param {string} dbColName 
 */
export function toTabColName(dbColName) {
    let dict = {
        "aid": "key",
        "areaName": "名称",
        "city": "地区（市）",
        "province": "地区（省）",
        "status": "状态",
        "areaCode": "编号"
    }
    return dict[dbColName];
}

